// apolloClient.ts
import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  split,
  defaultDataIdFromObject,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import createUploadLink from 'apollo-upload-client/createUploadLink.mjs';
import auth from '../../components/auth';
import { xhrProgressLink } from './xhrProgressLink';
import { adminCreatorsPageFieldPolicy } from '@client/new/pages/admin/influencer-list-new/model/adminCreatorsPage.cache';

const API_URL = import.meta.env.VITE_GRAPHQL_API_URL;
const UPLOAD_URL = `${import.meta.env.VITE_ADMIN_UPLOAD_BASE_URL}/graphql`;

const authLink = setContext((_, { headers = {} }) => ({
  headers: {
    'X-client-name': 'admin-panel-apollo', // ← added once
    ...headers, // ← caller can still override
    authorization: auth.getToken() ? `Bearer ${auth.getToken()}` : '',
  },
}));

const httpLink = new HttpLink({ uri: API_URL });
const uploadLink = createUploadLink({
  uri: UPLOAD_URL,
}) as unknown as ApolloLink;

/* choose the right path */
const UPLOAD_OPS = ['CreateImage', 'CreatePDF', 'UpdatePDF'] as const;

const link = ApolloLink.from([
  authLink,
  split(
    ({ operationName }) => UPLOAD_OPS.includes((operationName as any) ?? ''),
    ApolloLink.from([xhrProgressLink(UPLOAD_URL), uploadLink]),
    httpLink,
  ),
]);

const cache = new InMemoryCache({
  typePolicies: {
    Query: { fields: { adminCreatorsPage: adminCreatorsPageFieldPolicy } },
  },
  dataIdFromObject(obj) {
    if (obj.__typename === 'CRMUser') {
      return (
        obj.id +
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (obj.subscription as any)?.id +
        obj.leadId
      );
    }
    return defaultDataIdFromObject(obj);
  },
});

export const apolloClient = new ApolloClient({ link, cache });
